export default __webpack_public_path__ + "static/media/darkIcon.62727153.svg";